export const NeoDateCell: React.FC<any> = ({data, cellValue, type}) => {
  if (cellValue === 0) return "-";
  const timestamp = Number(cellValue);
  const date = new Date(timestamp);
  // console.log("NeoDateCell", timestamp, data, type);
  const formatTimestamp = (timestamp: string | number) => {
    const date = new Date(Number(timestamp));
    return isNaN(date.getTime())
      ? "-"
      : new Intl.DateTimeFormat("en-GB", {
          ...(type === "Date" && {
            day: "2-digit",
            month: "short",
            year: "numeric"
          }),
          ...(type === "Datetime" && {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          }),
          ...(type === "Time" && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          })
        }).format(date);
  };

  const formattedDate =
    type === "Time" && Array.isArray(cellValue)
      ? cellValue.map(formatTimestamp).join(" , ")
      : formatTimestamp(cellValue);
  return (
    <>
      <div className="flex items-center gap-1">
        {type === "Date" && (
          <svg
            width="12"
            height="12"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-gray-700 dark:text-gray-300"
          >
            <path
              d="M15 2H16.0049C17.1068 2 18 2.89451 18 3.99406V16.0059C18 17.1072 17.1074 18 16.0049 18H1.99509C0.893231 18 0 17.1055 0 16.0059V3.99406C0 2.89277 0.892622 2 1.99509 2H3V0.490479C3 0.219595 3.23193 0 3.5 0C3.77614 0 4 0.215057 4 0.490479V2H14V0.490479C14 0.219595 14.2319 0 14.5 0C14.7761 0 15 0.215057 15 0.490479V2ZM15 3V3.50952C15 3.78041 14.7681 4 14.5 4C14.2239 4 14 3.78494 14 3.50952V3H4V3.50952C4 3.78041 3.76807 4 3.5 4C3.22386 4 3 3.78494 3 3.50952V3H1.99509C1.44505 3 1 3.44491 1 3.99406V16.0059C1 16.5538 1.44614 17 1.99509 17H16.0049C16.5549 17 17 16.5551 17 16.0059V3.99406C17 3.44618 16.5539 3 16.0049 3H15ZM1 5H17V6H1V5ZM13 8.50468C13 8.22596 13.214 8 13.5047 8H14.4953C14.774 8 15 8.21404 15 8.50468V9.49532C15 9.77404 14.786 10 14.4953 10H13.5047C13.226 10 13 9.78596 13 9.49532V8.50468ZM8 8.50468C8 8.22596 8.21404 8 8.50468 8H9.49532C9.77404 8 10 8.21404 10 8.50468V9.49532C10 9.77404 9.78596 10 9.49532 10H8.50468C8.22596 10 8 9.78596 8 9.49532V8.50468ZM3 8.50468C3 8.22596 3.21404 8 3.50468 8H4.49532C4.77404 8 5 8.21404 5 8.50468V9.49532C5 9.77404 4.78596 10 4.49532 10H3.50468C3.22596 10 3 9.78596 3 9.49532V8.50468ZM3 13.5047C3 13.226 3.21404 13 3.50468 13H4.49532C4.77404 13 5 13.214 5 13.5047V14.4953C5 14.774 4.78596 15 4.49532 15H3.50468C3.22596 15 3 14.786 3 14.4953V13.5047ZM8 13.5047C8 13.226 8.21404 13 8.50468 13H9.49532C9.77404 13 10 13.214 10 13.5047V14.4953C10 14.774 9.78596 15 9.49532 15H8.50468C8.22596 15 8 14.786 8 14.4953V13.5047ZM13 13.5047C13 13.226 13.214 13 13.5047 13H14.4953C14.774 13 15 13.214 15 13.5047V14.4953C15 14.774 14.786 15 14.4953 15H13.5047C13.226 15 13 14.786 13 14.4953V13.5047Z"
              fill="black"
            />
          </svg>
        )}

        <span>{formattedDate}</span>
      </div>
    </>
  );
};
